export const state = () => ({
  data: {
  },
  session: {

  }
})

export const getters = {

}

export const actions = {
  async fetchSession ({ commit }, { $axios, eventId }) {
    try {
      let params = {}
      if (eventId !== null) {
        params.event_id = eventId
      }
      const { data } = await $axios.post('/api/v1/feonly/my_session', params)
      if (data.status === 200) {
        delete data.status
        commit('setSession', data)
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        // todo we should implement some course of action
        // throw new Error('Bad credentials')
      } else if (error.response && error.response.status === 400) {
        // todo we should implement some course of action
        // throw new Error('Bad credentials')
      } else {
        throw error
      }
    }
  },
  async fetchProfile ({ commit }, { $axios}) {
    try {
      const { data } = await $axios.post('/api/v1/user/profile')
      if (data.status === 200) {
        delete data.status
        commit('setData', data.user)
      }
    } catch (error) {
      console.log(error.response)
      if (error.response && error.response.status === 403) {
        // todo we should implement some course of action
        // throw new Error('Bad credentials')
      } else if (error.response && error.response.status === 400) {
        // todo we should implement some course of action
        // throw new Error('Bad credentials')
      } else {
        throw error
      }
    }
  },
}

export const mutations = {
  setData (state, dataData) {
    state.data = dataData
  },
  setSession (state, sessionData) {
    state.session = sessionData
  }
}
